import { useService } from '@/app/context/DIContext/useService'
import {
    EPGService,
    LoginAndProfileCodespot,
    TVService,
    VODService,
} from '@/shared/constants/servicesConstants'
import { IVODServiceToya } from '@/shared/services/types/vodService/vodServiceInterfaces'
import { ITVServiceToya } from '@/shared/services/types/tvService/tvServiceInterfaces'
import { IEPGServiceToya } from '@/shared/services/types/epgService/epgServiceInterfaces'
import { ILoginAndProfileService } from '@/shared/services/types/loginAndProfile/loginAndProfileTypes'

export const useVODService = () => useService<IVODServiceToya>(VODService)
export const useTVService = () => useService<ITVServiceToya>(TVService)
export const useEPGService = () => useService<IEPGServiceToya>(EPGService)
export const useLoginAndProfileService = () =>
    useService<ILoginAndProfileService>(LoginAndProfileCodespot)
